module.exports = __webpack_public_path__ + "img/gh-36020____-62.prt.f52aebe0.jpg";